module.exports = __webpack_public_path__ + "media/images/ico-delete-7d9e0afb.svg";